import React from 'react';
import ReactDOM from 'react-dom/client';
import './fonts.css';
import './i18n';
import { GlobalResets } from '@pr/components';
import { ThemeProvider } from 'styled-components';
import App from './App';
import Helmet from './Helmet';
import reportWebVitals from './reportWebVitals';

const isHunqz = process.env.REACT_APP_SITE === 'HUNQZ';
const skin = isHunqz ? 'hunqz' : 'romeo';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={{ skin }}>
      <Helmet />
      <GlobalResets />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
